import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

interface NameWithAvatarProps {
  fullName: string
  avatar: string
}

interface AccessOption {
  label: string
  value: number
  component: React.ReactNode
}

const NameWithAvatar = ({ fullName, avatar }: NameWithAvatarProps) => (
  <Box gap="s8" flexDirection="row" alignItems="center">
    <Avatar label={fullName} url={buildUrl(avatar)} size="s32" />
    <Text.Normal>{fullName}</Text.Normal>
  </Box>
)

const makeAccessesOptions = (accesses: User[]): AccessOption[] =>
  accesses.map((access: User) => ({
    label: access.fullName(),
    value: access.id,
    component: <NameWithAvatar fullName={access.fullName()} avatar={access.avatar || ''} />,
  }))

const deletedByFilter = (source: ReturnType<typeof useDocumentsDataTable>, accesses: User[]) => {
  const accessesOptions = makeAccessesOptions(accesses)
  const options = accessesOptions.sort((a, b) => a.label.localeCompare(b.label))

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Integer,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'deleted_by_id',
    path: 'deletedBy',
    title: i18n.t('documents.employee.filters.deleted_by'),
  })
}

export default deletedByFilter
